import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
// const officesTenerife = [
//   {name: 'aeropuerto sur',      icon: 'airport',  zone: 'Aeropuertos',  id: '30902', cityId: '31902', countryId: '1317'},
//   {name: 'aeropuerto norte',    icon: 'airport',  zone: 'Aeropuertos',  id: '30903', cityId: '31902', countryId: '1317'},
//   {name: 'central costa adeje', icon: 'office',   zone: 'Costa Adeje',  id: '30904', cityId: '31902', countryId: '1317'}
// ]

var oneDay = 24 * 60 * 60 * 1000;
var fromDate = new Date();
fromDate.setDate(fromDate.getDate() + 1);
var dayFrom = String(fromDate.getDate()).padStart(2, "0");
var monthFrom = String(fromDate.getMonth() + 1).padStart(2, "0"); //January is 0!
var yearFrom = fromDate.getFullYear();

var toDate = new Date();
toDate.setDate(toDate.getDate() + 8);
var dayTo = String(toDate.getDate()).padStart(2, "0");
var monthTo = String(toDate.getMonth() + 1).padStart(2, "0"); //January is 0!
var yearTo = toDate.getFullYear();

var diffdays = Math.round(Math.abs((fromDate - toDate) / oneDay));

var defaultPickupOfficeMode = "airportSouth"; // Change to "selectOffice" to require office selection again.
var defaultAirportSouthOffice = {
  location: "31909",
  name: "Aeropuerto Sur",
  cityId: "31902",
  countryId: "1317",
  zoneName: "Aeropuertos",
};

var getDefaultPickupOffice = function () {
  if (defaultPickupOfficeMode === "selectOffice") {
    return {
      location: "-1",
      name:
        window.searcherTranslations && window.searcherTranslations.selectOffice
          ? window.searcherTranslations.selectOffice
          : "Seleccione oficina de recogida",
      cityId: "-1",
      countryId: "1317",
      zoneName: "Aeropuertos",
    };
  }

  return defaultAirportSouthOffice;
};

var getDefaultDropoffOffice = function () {
  return defaultAirportSouthOffice;
};

if (!window.searcherGlobalState && process.env.NODE_ENV === "development") {
 window.searcherGlobalState = {
    tenerifeOffices: JSON.parse(
      '[{"id":-1,"idZone":-1,"idCity":-1,"city":"","name":"Seleccione oficina","type":"Seleccione","latitude":28.045702,"longitude":-16.576236,"karveId":"00","address":"Seleccione oficina","phone":"  +34  922714298","todayOpentime":"09:00 / 19:45","isCentral":true,"centralId":-1},{"id":7,"idZone":31909,"idCity":31902,"city":"Aeropuertos","name":"AEROPUERTO SUR","type":"Muelle","latitude":28.045702,"longitude":-16.576236,"karveId":"A1","address":"Aeropuerto Reina Sofia ","phone":"  +34  922714298","todayOpentime":"09:00 / 19:45","isCentral":true,"centralId":7},{"id":6,"idZone":31908,"idCity":31902,"city":"Aeropuertos","name":"AEROPUERTO NORTE","type":"Aeropuerto","latitude":28.484662,"longitude":-16.343368,"karveId":"A2","address":"San Cristóbal de La Laguna, Aeropuerto Los Rodeos ","phone":"+34  922714298","todayOpentime":"09:00 / 19:30","isCentral":true,"centralId":6},{"id":21,"idZone":31924,"idCity":32162,"city":"Costa Adeje","name":"TERRAZAS DEL DUQUE","type":"Oficina","latitude":28.092003,"longitude":-16.735671,"karveId":"D1","address":"Av. de Bruselas 14, The Duke Shops, PB7 38660, Adeje","phone":"+34  922714298","todayOpentime":"08:00 / 20:00","isCentral":true,"centralId":21},{"id":117,"idZone":32174,"idCity":31904,"city":"Golf del Sur","name":"HOTEL FANTASIA BAHIA PRINCIPE","type":"Hotel","latitude":28.0257452,"longitude":-16.6061688,"karveId":"OF","address":"Av. J.M. Galván Bello SN 38639, Golf del Sur","phone":"+34 922792919","todayOpentime":"08:30 / 12:30 - 16:30 / 19:30","isCentral":false,"centralId":10},{"id":31,"idZone":31934,"idCity":31903,"city":"Playa de las Américas","name":"CENTRAL PLAZA ARONA","type":"Oficina","latitude":28.05485,"longitude":-16.729599,"karveId":"C1","address":"Av. las Américas, 7, C.C. Americas Plaza 38660, Arona","phone":"+34  922792919","todayOpentime":"08:00 / 14:00 - 17:00 / 20:00","isCentral":true,"centralId":31},{"id":10,"idZone":31912,"idCity":31904,"city":"Golf del Sur","name":"CENTRAL GOLF DEL SUR","type":"Oficina","latitude":28.027745,"longitude":-16.610948,"karveId":"O7","address":"Av. J.M. Galván Bello, s/n, Hotel Golf Plaza 38620, Golf del Sur","phone":"+34  922738060","todayOpentime":"09:00 / 13:00 - 17:00 / 20:00","isCentral":true,"centralId":10},{"id":75,"idZone":32166,"idCity":31907,"city":"Puerto de la Cruz","name":"CENTRAL PUERTO DE LA CRUZ","type":"Hotel","latitude":28.410582,"longitude":-16.557913,"karveId":"Q5","address":"Calle Antonio Ruiz Alvarez, 7, Hotel Turquesa 38400, Puerto de la Cruz","phone":"  +34  922388456","todayOpentime":"08:30 / 13:00 - 17:00 / 20:00","isCentral":false,"centralId":29},{"id":11,"idZone":31913,"idCity":31905,"city":"Guía de Isora","name":"HOTEL ABAMA","type":"Hotel","latitude":28.170631,"longitude":-16.800476,"karveId":"AB","address":"Carretera General del Sur TF-47, km 9 38687, Guía de Isora","phone":"+34  922714298","todayOpentime":"8:30 / 12:30 - 16:30 / 19:30","isCentral":true,"centralId":11},{"id":114,"idZone":32170,"idCity":32171,"city":"El Médano","name":"HOTEL ARENAS DEL MAR","type":"Hotel","latitude":28.0503757,"longitude":-16.5310077,"karveId":"OM","address":"Av. Europa, 2 38612, El Médano","phone":"+34 922714298","todayOpentime":"08:30 / 12:30","isCentral":false,"centralId":31},{"id":76,"idZone":32164,"idCity":32163,"city":"Los Gigantes","name":"HOTEL LANDMAR LOS GIGANTES","type":"Hotel","latitude":28.234113,"longitude":-16.837001,"karveId":"PG","address":"Juan Manuel Capdevielle, 8 38683, Puerto Santiago","phone":"   +34  922714298","todayOpentime":"08:30 / 12:30 - 16:30 / 19:30","isCentral":true,"centralId":76},{"id":26,"idZone":31929,"idCity":31906,"city":"Playa Paraíso","name":"PLAYA PARAISO - FRENTE AL HARD ROCK","type":"Hotel","latitude":28.121909,"longitude":-16.774721,"karveId":"P1","address":"Av. Adeje 300, 12, Local 10 38678, Adeje","phone":"+34  922714298","todayOpentime":"09:00 / 12:30","isCentral":true,"centralId":26},{"id":83,"idZone":32168,"idCity":32162,"city":"Costa Adeje","name":"HOTEL BAHÍA DEL DUQUE","type":"Hotel","latitude":28.09323,"longitude":-16.742082,"karveId":"DY","address":"Avenida Bruselas, s/n 38660, Adeje","phone":"  +34  922714298","todayOpentime":"08:30 / 12:30 - 16:30 / 19:30","isCentral":false,"centralId":21},{"id":17,"idZone":31920,"idCity":31903,"city":"Playa de las Américas","name":"HOTEL H10 CONQUISTADOR","type":"Oficina","latitude":28.057673,"longitude":-16.73502,"karveId":"C7","address":"Av. Rafael Puig Lluvina, 36 38660, Adeje","phone":"+34  922792919","todayOpentime":"09:00 / 13:00 - 16:30 / 19:30","isCentral":false,"centralId":31},{"id":119,"idZone":32176,"idCity":31906,"city":"Playa Paraíso","name":"HOTEL H10 ATLANTIC SUNSET","type":"Hotel","latitude":28.11855,"longitude":-16.7780378,"karveId":"PN","address":"Av. Adeje 300, s/n ","phone":"","todayOpentime":"08:30 / 12:30 - 17:00 / 20:00","isCentral":false,"centralId":26},{"id":28,"idZone":31931,"idCity":31906,"city":"Playa Paraíso","name":"HOTEL ROCA DE NIVARIA","type":"Hotel","latitude":28.120509,"longitude":-16.776968,"karveId":"PP","address":"Av. Adeje 300, s/n 38678, Adeje","phone":"+34  922714298","todayOpentime":"08:30 / 12:30 - 17:00 / 20:00","isCentral":false,"centralId":26}]'
    ),
  };
}

if (!window.searcherTranslations && process.env.NODE_ENV === "development") {
  window.searcherTranslations = {
    language: "es",
    errors: {
      closeWindow: "Chiudi",
      missPickupLocation: { title: "Errore", message: "Ufficio Pickup" },
      missDropoffLocation: { title: "Errore", message: "Ufficio Resituzione" },
      missPickupDate: { title: "Errore", message: "Data Pickup" },
      missDropoffDate: { title: "Errore", message: "Data Restituzione" },
      missPickupTime: { title: "Errore", message: "Orario Pickup" },
      missDropoffTime: { title: "Errore", message: "Orario Restituzone" },
      wrongNumDays: { title: "Errore", message: "Numero giorni" },
      missEdadConductor: { title: "Errore", message: "Etá del conducente" },
      missOtherHotelPickup: { title: "Errore", message: "Altro Hotel Pickup" },
      selectedPickUpOffice: { title: "Error", message: "Seleccione oficina de recogida"},
      missOtherHotelDropoff: {
        title: "Errore",
        message: "Altro Hotel Restituzione",
      },
      wrongDates: { title: "Errore", message: "Date Errate" },
      wrongEdadConductor: { title: "Errore", message: "Etá Conducente Errata" },
    },
    pickupOffice: "Oficina de recogida",
    dropoffOffice: "Oficina de devolución",
    datePickup: "Fecha y hora de recogida",
    dateDropOff: "Fecha y hora de devolución",
    reservationLeyend1: "Duración de la reserva:",
    daysM: "Días",
    days: "días",
    age: "Edad",
    otherHotels: "Atri Hotel",
    selectOffice: "Seleccione oficina de recogida",
    searchingInProgress: "Ricerca in corso",
    searcherResultFor: "Risultati per",
    tenerife: "Tenerife",
    searcherPlaceholders: ["sp 1", "sp 2", "sp 3", "sp4"],
    myActualLocation: "Posizione Attuale",
    resultsFor: "Risultati per",
    wePickupYouAt: "Ti prendiamo a",

    // new translations
    textRegularDriver: "+25 anni",
    textYoungDriver21: "da 21 a 22 anni",
    textYoungDriver23: "da 23 a 24 anni",
    textSearchButton: "Cerca",
    world: "Mondo",
    searchForAPlace: "Scrivi un luogo, un aeroporto, un indirizzo, ...",
  };
}

var defaultPickupOffice = getDefaultPickupOffice();
var defaultDropoffOffice = getDefaultDropoffOffice();

if (!window.searcherParams && process.env.NODE_ENV === "development") {
  window.searcherParams = {
    pickupLocation: defaultPickupOffice.location,
    pickupLocationName: defaultPickupOffice.name,
    pickupCityId: defaultPickupOffice.cityId,
    pickupCountryId: defaultPickupOffice.countryId,
    pickupDate: { day: dayFrom, month: monthFrom, year: yearFrom },
    pickupTime: "10:00",
    days: diffdays,
    dropoffLocation: defaultDropoffOffice.location,
    dropoffLocationName: defaultDropoffOffice.name,
    dropoffCityId: defaultDropoffOffice.cityId,
    dropoffDate: { day: dayTo, month: monthTo, year: yearTo },
    dropoffTime: "10:00",
    driverAge: "44",
    driverType: 3,
    maxHoursForAddDay: 4,
    zonaBusquedaPickup: defaultPickupOffice.zoneName,
    zonaBusquedaDropoff: defaultDropoffOffice.zoneName,
    modelo: "",
    onSearchSendExternalLink: false,
    affiliateId: "",
    isWhiteLabel: false,
    forceShowMap: false,
    // tenerifeMoreThan25Years: false,
    // tenerif21Years: false,
  };
} else {
  window.searcherParams = {
    pickupLocation:
      // window.searcherGlobalState.pickuplocation != ""
      //   ? window.searcherGlobalState.pickuplocation
      //   : "-1",
      window.searcherGlobalState.pickuplocation != ""
        ? window.searcherGlobalState.pickuplocation
        : defaultPickupOffice.location,
    pickupLocationName:
      // window.searcherGlobalState.pickuplocationame != ""
      //   ? window.searcherGlobalState.pickuplocationame
      //   : window.searcherTranslations.selectOffice,
      window.searcherGlobalState.pickuplocationame != ""
        ? window.searcherGlobalState.pickuplocationame
        : defaultPickupOffice.name,
    pickupCityId:
      // window.searcherGlobalState.pickupcityid != ""
      //   ? window.searcherGlobalState.pickupcityid
      //   : "-1",
      window.searcherGlobalState.pickupcityid != ""
        ? window.searcherGlobalState.pickupcityid
        : defaultPickupOffice.cityId,
    pickupCountryId:
      window.searcherGlobalState.pickupcountryid != ""
        ? window.searcherGlobalState.pickupcountryid
        : defaultPickupOffice.countryId,
    pickupDate:
      window.searcherGlobalState.timefrom != ""
        ? {
            day: window.searcherGlobalState.dayfrom,
            month: window.searcherGlobalState.monthfrom,
            year: window.searcherGlobalState.yearfrom,
          }
        : { day: dayFrom, month: monthFrom, year: yearFrom },
    pickupTime:
      window.searcherGlobalState.timefrom != ""
        ? window.searcherGlobalState.timefrom
        : "10:00",
    days:
      window.searcherGlobalState.days != ""
        ? window.searcherGlobalState.days
        : diffdays,
    dropoffLocation:
      window.searcherGlobalState.dropofflocation != ""
        ? window.searcherGlobalState.dropofflocation
        : defaultDropoffOffice.location,
    dropoffLocationName:
      window.searcherGlobalState.dropoffcityid != ""
        ? window.searcherGlobalState.dropofflocationame
        : defaultDropoffOffice.name,
    dropoffCityId:
      window.searcherGlobalState.dropoffcityid != ""
        ? window.searcherGlobalState.dropoffcityid
        : defaultDropoffOffice.cityId,
    dropoffDate:
      window.searcherGlobalState.timeto != ""
        ? {
            day: window.searcherGlobalState.dayto,
            month: window.searcherGlobalState.monthto,
            year: window.searcherGlobalState.yearto,
          }
        : { day: dayTo, month: monthTo, year: yearTo },
    dropoffTime:
      window.searcherGlobalState.timeto != ""
        ? window.searcherGlobalState.timeto
        : "10:00",
    driverAge:
      window.searcherGlobalState.driverage != ""
        ? window.searcherGlobalState.driverage
        : "44",
    zonaBusquedaPickup:
      window.searcherGlobalState.zonabusquedapickup != ""
        ? window.searcherGlobalState.zonabusquedapickup
        : defaultPickupOffice.zoneName,
    zonaBusquedaDropoff:
      window.searcherGlobalState.zonabusquedadropoff != ""
        ? window.searcherGlobalState.zonabusquedadropoff
        : defaultDropoffOffice.zoneName,
    modelo: "",
    onSearchSendExternalLink: false,
    affiliateId: "",
    isWhiteLabel: false,
    forceShowMap: false,
    maxHoursForAddDay: window.searcherGlobalState.maxHoursForAddDay,
    // tenerifeMoreThan25Years: false,
    driverType: 
       window.searcherGlobalState.driverType != ""
        ? window.searcherGlobalState.driverType
        : 3,
  };
}

ReactDOM.render(
  <React.StrictMode>
    <div className="page-container">
      <App
        officesTenerife={window.searcherGlobalState.tenerifeOffices.map(
          (office) => ({ ...office, pickupCountryId: 1317 })
        )}
        translations={window.searcherTranslations}
        defaultParams={window.searcherParams}
      />
    </div>
  </React.StrictMode>,
  document.getElementById("root")
);
